export default () => ({
  autocomplete: {
    height: '60px',
  }
});